import { render, staticRenderFns } from "./IrReportGenerator.vue?vue&type=template&id=40cbbef5&"
import script from "./IrReportGenerator.js?vue&type=script&lang=js&"
export * from "./IrReportGenerator.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports